var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4180_2723)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.70096 11.9001L3.48096 6.9249C3.42508 6.86916 3.38075 6.80295 3.35051 6.73006C3.32026 6.65716 3.30469 6.57902 3.30469 6.5001C3.30469 6.42118 3.32026 6.34303 3.35051 6.27014C3.38075 6.19724 3.42508 6.13103 3.48096 6.0753L8.70096 1.1001",
  stroke: "#333333",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4180_2723"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
export default SvgChevronLeft;